import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import styles from './spinner.module.css';

const  spinner = () => {
  return (
      <div>
        <div className={ styles.mask }></div>
        <div className={ styles.progress }>
          <CircularProgress size={ 100 } color={'inherit'}/>
        </div>
      </div>
  )
}

export default spinner;